// Generated by ReScript, PLEASE EDIT WITH CARE

import AcademySvg from "./assets/Academy.svg";
import StarFilledSvg from "./assets/star-filled.svg";
import StarUnfilledSvg from "./assets/star-unfilled.svg";
import HatsSvg from "./assets/K-2 Comprehension/K/Hats.svg";
import Numerals0Svg from "./assets/handwriting/Numerals 0-9.svg";
import BookSvg from "./assets/senior_strand_icons/Book.svg";
import FruitSvg from "./assets/K-2 Comprehension/K/Fruit.svg";
import MonkeySvg from "./assets/K-2 Comprehension/K/Monkey.svg";
import TrucksSvg from "./assets/K-2 Comprehension/K/Trucks.svg";
import KittensSvg from "./assets/K-2 Comprehension/K/Kittens.svg";
import GrammarSvg from "./assets/junior_strand_icons/Grammar.svg";
import PhonicsSvg from "./assets/junior_strand_icons/Phonics.svg";
import WritingSvg from "./assets/junior_strand_icons/Writing.svg";
import GrammarSvg$1 from "./assets/senior_strand_icons/Grammar.svg";
import ChickensSvg from "./assets/K-2 Comprehension/K/Chickens.svg";
import HensEggSvg from "./assets/K-2 Comprehension/K/Hens Egg.svg";
import SpellingSvg from "./assets/junior_strand_icons/Spelling.svg";
import SpellingSvg$1 from "./assets/senior_strand_icons/Spelling.svg";
import JensPugSvg from "./assets/K-2 Comprehension/K/Jen's Pug.svg";
import SillyFoxSvg from "./assets/K-2 Comprehension/K/Silly Fox.svg";
import OwlsSvg from "./assets/K-2 Comprehension/Year 2/Owls.svg";
import DecodableSvg from "./assets/junior_strand_icons/Decodable.svg";
import MyWeatherSvg from "./assets/K-2 Comprehension/K/My Weather.svg";
import WaterSvg from "./assets/K-2 Comprehension/Year 1/Water.svg";
import Numeral0Svg from "./assets/handwriting/Numerals/Numeral 0.svg";
import Numeral1Svg from "./assets/handwriting/Numerals/Numeral 1.svg";
import Numeral2Svg from "./assets/handwriting/Numerals/Numeral 2.svg";
import Numeral3Svg from "./assets/handwriting/Numerals/Numeral 3.svg";
import Numeral4Svg from "./assets/handwriting/Numerals/Numeral 4.svg";
import Numeral5Svg from "./assets/handwriting/Numerals/Numeral 5.svg";
import Numeral6Svg from "./assets/handwriting/Numerals/Numeral 6.svg";
import Numeral7Svg from "./assets/handwriting/Numerals/Numeral 7.svg";
import Numeral8Svg from "./assets/handwriting/Numerals/Numeral 8.svg";
import Numeral9Svg from "./assets/handwriting/Numerals/Numeral 9.svg";
import ILikeDogsSvg from "./assets/K-2 Comprehension/K/I Like Dogs.svg";
import OttersSvg from "./assets/K-2 Comprehension/Year 2/Otters.svg";
import PoliceSvg from "./assets/K-2 Comprehension/Year 2/Police.svg";
import HandwritingSvg from "./assets/junior_strand_icons/Handwriting.svg";
import Sight_WordsSvg from "./assets/junior_strand_icons/Sight_Words.svg";
import AnimalHomesSvg from "./assets/K-2 Comprehension/K/Animal Homes.svg";
import CatsorDogsSvg from "./assets/K-2 Comprehension/K/Cats or Dogs.svg";
import CricketSvg from "./assets/K-2 Comprehension/Year 2/Cricket.svg";
import DoctorsSvg from "./assets/K-2 Comprehension/Year 2/Doctors.svg";
import CatandMouseSvg from "./assets/K-2 Comprehension/K/Cat and Mouse.svg";
import PenguinsSvg from "./assets/K-2 Comprehension/Year 1/Penguins.svg";
import TeachersSvg from "./assets/K-2 Comprehension/Year 2/Teachers.svg";
import Numerals0Svg$1 from "./assets/handwriting/Numerals/Numerals 0-4.svg";
import Numerals0Svg$2 from "./assets/handwriting/Numerals/Numerals 0-9.svg";
import Numerals1Svg from "./assets/handwriting/Numerals/Numerals 1-3.svg";
import Numerals4Svg from "./assets/handwriting/Numerals/Numerals 4-6.svg";
import Numerals5Svg from "./assets/handwriting/Numerals/Numerals 5-9.svg";
import Numerals7Svg from "./assets/handwriting/Numerals/Numerals 7-9.svg";
import ZigZagLetterFamilySvg from "./assets/handwriting/Zig-Zag Letter Family.svg";
import ComprehensionSvg from "./assets/junior_strand_icons/Comprehension.svg";
import ComprehensionSvg$1 from "./assets/senior_strand_icons/Comprehension.svg";
import MugCakesSvg from "./assets/K-2 Comprehension/Year 1/Mug Cakes.svg";
import LandmarksSvg from "./assets/K-2 Comprehension/Year 2/Landmarks.svg";
import DippyEggsSvg from "./assets/K-2 Comprehension/Year 1/Dippy Eggs.svg";
import EricCarleSvg from "./assets/K-2 Comprehension/Year 2/Eric Carle.svg";
import GrowingTomatoesSvg from "./assets/K-2 Comprehension/K/Growing Tomatoes.svg";
import MakingBreakfastSvg from "./assets/K-2 Comprehension/K/Making Breakfast.svg";
import OhnoBrianSvg from "./assets/K-2 Comprehension/Year 1/Oh no Brian.svg";
import TotheMoonSvg from "./assets/K-2 Comprehension/Year 1/To the Moon.svg";
import ShopkeepersSvg from "./assets/K-2 Comprehension/Year 2/Shopkeepers.svg";
import CurlyLineLetterFamilySvg from "./assets/handwriting/Curly Line Letter Family.svg";
import Spell_testSvg from "./assets/tupperware_activity_icons/spell_test.svg";
import DavidsEyesSvg from "./assets/K-2 Comprehension/Year 2/David's Eyes.svg";
import BouncyLineLetterFamilySvg from "./assets/handwriting/Bouncy Line Letter Family.svg";
import MothersandBabiesSvg from "./assets/K-2 Comprehension/K/Mothers and Babies.svg";
import WeGrowVegetablesSvg from "./assets/K-2 Comprehension/K/We Grow Vegetables.svg";
import FruityKebabsSvg from "./assets/K-2 Comprehension/Year 2/Fruity Kebabs.svg";
import Grammar_iconSvg from "./assets/tupperware_activity_icons/grammar_icon.svg";
import BugsBirthdaySvg from "./assets/K-2 Comprehension/Year 1/Bug's Birthday.svg";
import BananaMuffinsSvg from "./assets/K-2 Comprehension/Year 2/Banana Muffins.svg";
import StraightLineLetterFamilySvg from "./assets/handwriting/Straight Line Letter Family.svg";
import Spelling_iconSvg from "./assets/tupperware_activity_icons/spelling_icon.svg";
import CityorCountrySvg from "./assets/K-2 Comprehension/Year 1/City or Country.svg";
import ATriptoKoreaSvg from "./assets/K-2 Comprehension/Year 2/A Trip to Korea.svg";
import SeeMeBrushMyTeethSvg from "./assets/K-2 Comprehension/K/See Me Brush My Teeth.svg";
import HowtoDrawaCatSvg from "./assets/K-2 Comprehension/Year 1/How to Draw a Cat.svg";
import KoalasBikeTripSvg from "./assets/K-2 Comprehension/Year 1/Koala's Bike Trip.svg";
import NoHaircutforMeSvg from "./assets/K-2 Comprehension/Year 1/No Haircut for Me.svg";
import StrawberryPickingSvg from "./assets/K-2 Comprehension/Year 1/Strawberry Picking.svg";
import MyDadtheMailmanSvg from "./assets/K-2 Comprehension/Year 2/My Dad the Mailman.svg";
import MyUnclethePilotSvg from "./assets/K-2 Comprehension/Year 2/My Uncle the Pilot.svg";
import StrawberrySmoothieSvg from "./assets/K-2 Comprehension/Year 1/Strawberry Smoothie.svg";
import Comprehension_iconSvg from "./assets/tupperware_activity_icons/comprehension_icon.svg";
import CampinginAustraliaSvg from "./assets/K-2 Comprehension/Year 2/Camping in Australia.svg";
import LittleTigersLooseToothSvg from "./assets/K-2 Comprehension/K/Little Tiger's Loose Tooth.svg";
import CityMouseBushMouseSvg from "./assets/K-2 Comprehension/Year 2/City Mouse Bush Mouse.svg";
import SaraSnailsSleepoverSvg from "./assets/K-2 Comprehension/Year 2/Sara Snail's Sleepover.svg";
import ComprehensionLevel1Png from "./assets/Comprehension_Levels_Icons/Comprehension Level 1.png";
import ComprehensionLevel1Svg from "./assets/Comprehension_Levels_Icons/Comprehension Level 1.svg";
import ComprehensionLevel2Png from "./assets/Comprehension_Levels_Icons/Comprehension Level 2.png";
import ComprehensionLevel2Svg from "./assets/Comprehension_Levels_Icons/Comprehension Level 2.svg";
import ComprehensionLevel3Png from "./assets/Comprehension_Levels_Icons/Comprehension Level 3.png";
import ComprehensionLevel3Svg from "./assets/Comprehension_Levels_Icons/Comprehension Level 3.svg";
import ComprehensionLevel4Png from "./assets/Comprehension_Levels_Icons/Comprehension Level 4.png";
import ComprehensionLevel4Svg from "./assets/Comprehension_Levels_Icons/Comprehension Level 4.svg";
import PenguinsSnowConeShopSvg from "./assets/K-2 Comprehension/Year 1/Penguin's Snow Cone Shop.svg";
import LittleSlothsNewFriendSvg from "./assets/K-2 Comprehension/Year 1/Little Sloth's New Friend.svg";
import CheeseandVegemiteScrollsSvg from "./assets/K-2 Comprehension/Year 2/Cheese and Vegemite Scrolls.svg";
import LetterFormationASvg from "./assets/handwriting/Capital Letter Formation/Letter Formation A.svg";
import LetterFormationBSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation B.svg";
import LetterFormationCSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation C.svg";
import LetterFormationDSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation D.svg";
import LetterFormationESvg from "./assets/handwriting/Capital Letter Formation/Letter Formation E.svg";
import LetterFormationFSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation F.svg";
import LetterFormationGSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation G.svg";
import LetterFormationHSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation H.svg";
import LetterFormationISvg from "./assets/handwriting/Capital Letter Formation/Letter Formation I.svg";
import LetterFormationJSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation J.svg";
import LetterFormationKSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation K.svg";
import LetterFormationLSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation L.svg";
import LetterFormationMSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation M.svg";
import LetterFormationNSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation N.svg";
import LetterFormationOSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation O.svg";
import LetterFormationPSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation P.svg";
import LetterFormationQSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation Q.svg";
import LetterFormationRSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation R.svg";
import LetterFormationSSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation S.svg";
import LetterFormationTSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation T.svg";
import LetterFormationUSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation U.svg";
import LetterFormationVSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation V.svg";
import LetterFormationWSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation W.svg";
import LetterFormationXSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation X.svg";
import LetterFormationYSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation Y.svg";
import LetterFormationZSvg from "./assets/handwriting/Capital Letter Formation/Letter Formation Z.svg";
import LetterFormationaSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation a.svg";
import LetterFormationbSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation b.svg";
import LetterFormationcSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation c.svg";
import LetterFormationdSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation d.svg";
import LetterFormationeSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation e.svg";
import LetterFormationfSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation f.svg";
import LetterFormationgSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation g.svg";
import LetterFormationhSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation h.svg";
import LetterFormationiSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation i.svg";
import LetterFormationjSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation j.svg";
import LetterFormationkSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation k.svg";
import LetterFormationlSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation l.svg";
import LetterFormationmSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation m.svg";
import LetterFormationnSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation n.svg";
import LetterFormationoSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation o.svg";
import LetterFormationpSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation p.svg";
import LetterFormationqSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation q.svg";
import LetterFormationrSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation r.svg";
import LetterFormationsSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation s.svg";
import LetterFormationtSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation t.svg";
import LetterFormationuSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation u.svg";
import LetterFormationvSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation v.svg";
import LetterFormationwSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation w.svg";
import LetterFormationxSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation x.svg";
import LetterFormationySvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation y.svg";
import LetterFormationzSvg from "./assets/handwriting/Lowercase Letter Formation/Letter Formation z.svg";
import ChildrenShouldLearnHowtoCookSvg from "./assets/K-2 Comprehension/Year 1/Children Should Learn How to Cook.svg";
import PeopleShouldGrowTheirOwnFoodSvg from "./assets/K-2 Comprehension/Year 2/People Should Grow Their Own Food.svg";
import SwimmingLessonsforLittlePlatypusSvg from "./assets/K-2 Comprehension/Year 1/Swimming Lessons for Little Platypus.svg";
import LetterFormationAaSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Aa.svg";
import LetterFormationBbSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Bb.svg";
import LetterFormationCcSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Cc.svg";
import LetterFormationDdSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Dd.svg";
import LetterFormationEeSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ee.svg";
import LetterFormationFfSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ff.svg";
import LetterFormationGgSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Gg.svg";
import LetterFormationHhSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Hh.svg";
import LetterFormationIiSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ii.svg";
import LetterFormationJjSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Jj.svg";
import LetterFormationKkSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Kk.svg";
import LetterFormationLlSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ll.svg";
import LetterFormationMmSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Mm.svg";
import LetterFormationNnSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Nn.svg";
import LetterFormationOoSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Oo.svg";
import LetterFormationPpSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Pp.svg";
import LetterFormationQqSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Qq.svg";
import LetterFormationRrSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Rr.svg";
import LetterFormationSsSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ss.svg";
import LetterFormationTtSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Tt.svg";
import LetterFormationUuSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Uu.svg";
import LetterFormationVvSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Vv.svg";
import LetterFormationWwSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Ww.svg";
import LetterFormationXxSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Xx.svg";
import LetterFormationYySvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Yy.svg";
import LetterFormationZzSvg from "./assets/handwriting/Capital and Lower Letter Formation/Letter Formation Zz.svg";

import './parallax.css'
;

var academyHouseSvg = AcademySvg;

var comprehensionStrandIcon = ComprehensionSvg;

var decodableStrandIcon = DecodableSvg;

var grammarStrandIcon = GrammarSvg;

var handwritingStrandIcon = HandwritingSvg;

var bouncyLineLetterFamilyIcon = BouncyLineLetterFamilySvg;

var curlyLineLetterFamilyIcon = CurlyLineLetterFamilySvg;

var straightLineLetterFamilyIcon = StraightLineLetterFamilySvg;

var zigZagLetterFamilyIcon = ZigZagLetterFamilySvg;

var numeralsZeroToNineIcon = Numerals0Svg;

var phonicsStrandIcon = PhonicsSvg;

var sightWordsStrandIcon = Sight_WordsSvg;

var spellingStrandIcon = SpellingSvg;

var writingStrandIcon = WritingSvg;

var seniorBookStrandIcon = BookSvg;

var seniorComprehensionStrandIcon = ComprehensionSvg$1;

var seniorGrammarStrandIcon = GrammarSvg$1;

var seniorSpellingStrandIcon = SpellingSvg$1;

var starFilledSvg = StarFilledSvg;

var starUnfilledSvg = StarUnfilledSvg;

var grammarActivityIcon = Grammar_iconSvg;

var comprehensionActivityIcon = Comprehension_iconSvg;

var spellingLessonActivityIcon = Spelling_iconSvg;

var spellTestActivityIcon = Spell_testSvg;

var level1Png = ComprehensionLevel1Png;

var level1Svg = ComprehensionLevel1Svg;

var level2Png = ComprehensionLevel2Png;

var level2Svg = ComprehensionLevel2Svg;

var level3Png = ComprehensionLevel3Png;

var level3Svg = ComprehensionLevel3Svg;

var level4Png = ComprehensionLevel4Png;

var level4Svg = ComprehensionLevel4Svg;

var animalHomes = AnimalHomesSvg;

var catAndMouse = CatandMouseSvg;

var catsOrDogs = CatsorDogsSvg;

var chickens = ChickensSvg;

var fruit = FruitSvg;

var growingTomatoes = GrowingTomatoesSvg;

var weGrowVegetables = WeGrowVegetablesSvg;

var hats = HatsSvg;

var hensEgg = HensEggSvg;

var iLikeDogs = ILikeDogsSvg;

var jensPug = JensPugSvg;

var kittens = KittensSvg;

var littleTigersLooseTooth = LittleTigersLooseToothSvg;

var makingBreakfast = MakingBreakfastSvg;

var monkey = MonkeySvg;

var mothersAndBabies = MothersandBabiesSvg;

var myWeather = MyWeatherSvg;

var seeMeBrushMyTeeth = SeeMeBrushMyTeethSvg;

var sillyFox = SillyFoxSvg;

var trucks = TrucksSvg;

var K = {
  animalHomes: animalHomes,
  catAndMouse: catAndMouse,
  catsOrDogs: catsOrDogs,
  chickens: chickens,
  fruit: fruit,
  growingTomatoes: growingTomatoes,
  weGrowVegetables: weGrowVegetables,
  hats: hats,
  hensEgg: hensEgg,
  iLikeDogs: iLikeDogs,
  jensPug: jensPug,
  kittens: kittens,
  littleTigersLooseTooth: littleTigersLooseTooth,
  makingBreakfast: makingBreakfast,
  monkey: monkey,
  mothersAndBabies: mothersAndBabies,
  myWeather: myWeather,
  seeMeBrushMyTeeth: seeMeBrushMyTeeth,
  sillyFox: sillyFox,
  trucks: trucks
};

var bugsBirthday = BugsBirthdaySvg;

var childrenShouldLearnHowToCook = ChildrenShouldLearnHowtoCookSvg;

var cityOrCountry = CityorCountrySvg;

var dippyEggs = DippyEggsSvg;

var howToDrawACat = HowtoDrawaCatSvg;

var koalasBikeTrip = KoalasBikeTripSvg;

var littleSlothsNewFriend = LittleSlothsNewFriendSvg;

var mugCakes = MugCakesSvg;

var noHaircutForMe = NoHaircutforMeSvg;

var ohNoBrian = OhnoBrianSvg;

var penguinsSnowConeShop = PenguinsSnowConeShopSvg;

var penguins = PenguinsSvg;

var strawberryPicking = StrawberryPickingSvg;

var strawberrySmoothie = StrawberrySmoothieSvg;

var swimmingLessonsForLittlePlatypus = SwimmingLessonsforLittlePlatypusSvg;

var toTheMoon = TotheMoonSvg;

var water = WaterSvg;

var Year1 = {
  bugsBirthday: bugsBirthday,
  childrenShouldLearnHowToCook: childrenShouldLearnHowToCook,
  cityOrCountry: cityOrCountry,
  dippyEggs: dippyEggs,
  howToDrawACat: howToDrawACat,
  koalasBikeTrip: koalasBikeTrip,
  littleSlothsNewFriend: littleSlothsNewFriend,
  mugCakes: mugCakes,
  noHaircutForMe: noHaircutForMe,
  ohNoBrian: ohNoBrian,
  penguinsSnowConeShop: penguinsSnowConeShop,
  penguins: penguins,
  strawberryPicking: strawberryPicking,
  strawberrySmoothie: strawberrySmoothie,
  swimmingLessonsForLittlePlatypus: swimmingLessonsForLittlePlatypus,
  toTheMoon: toTheMoon,
  water: water
};

var aTripToKorea = ATriptoKoreaSvg;

var bananaMuffins = BananaMuffinsSvg;

var campingInAustralia = CampinginAustraliaSvg;

var cheeseAndVegemiteScrolls = CheeseandVegemiteScrollsSvg;

var cityMouseBushMouse = CityMouseBushMouseSvg;

var cricket = CricketSvg;

var davidsEyes = DavidsEyesSvg;

var doctors = DoctorsSvg;

var ericCarle = EricCarleSvg;

var fruityKebabs = FruityKebabsSvg;

var landmarks = LandmarksSvg;

var myDadTheMailman = MyDadtheMailmanSvg;

var myUncleThePilot = MyUnclethePilotSvg;

var otters = OttersSvg;

var owls = OwlsSvg;

var peopleShouldGrowTheirOwnFood = PeopleShouldGrowTheirOwnFoodSvg;

var police = PoliceSvg;

var saraSnailsSleepover = SaraSnailsSleepoverSvg;

var shopkeepers = ShopkeepersSvg;

var teachers = TeachersSvg;

var Year2 = {
  aTripToKorea: aTripToKorea,
  bananaMuffins: bananaMuffins,
  campingInAustralia: campingInAustralia,
  cheeseAndVegemiteScrolls: cheeseAndVegemiteScrolls,
  cityMouseBushMouse: cityMouseBushMouse,
  cricket: cricket,
  davidsEyes: davidsEyes,
  doctors: doctors,
  ericCarle: ericCarle,
  fruityKebabs: fruityKebabs,
  landmarks: landmarks,
  myDadTheMailman: myDadTheMailman,
  myUncleThePilot: myUncleThePilot,
  otters: otters,
  owls: owls,
  peopleShouldGrowTheirOwnFood: peopleShouldGrowTheirOwnFood,
  police: police,
  saraSnailsSleepover: saraSnailsSleepover,
  shopkeepers: shopkeepers,
  teachers: teachers
};

var ComprehensionLevels = {
  level1Png: level1Png,
  level1Svg: level1Svg,
  level2Png: level2Png,
  level2Svg: level2Svg,
  level3Png: level3Png,
  level3Svg: level3Svg,
  level4Png: level4Png,
  level4Svg: level4Svg,
  K: K,
  Year1: Year1,
  Year2: Year2
};

var a = LetterFormationAaSvg;

var b = LetterFormationBbSvg;

var c = LetterFormationCcSvg;

var d = LetterFormationDdSvg;

var e = LetterFormationEeSvg;

var f = LetterFormationFfSvg;

var g = LetterFormationGgSvg;

var h = LetterFormationHhSvg;

var i = LetterFormationIiSvg;

var j = LetterFormationJjSvg;

var k = LetterFormationKkSvg;

var l = LetterFormationLlSvg;

var m = LetterFormationMmSvg;

var n = LetterFormationNnSvg;

var o = LetterFormationOoSvg;

var p = LetterFormationPpSvg;

var q = LetterFormationQqSvg;

var r = LetterFormationRrSvg;

var s = LetterFormationSsSvg;

var t = LetterFormationTtSvg;

var u = LetterFormationUuSvg;

var v = LetterFormationVvSvg;

var w = LetterFormationWwSvg;

var x = LetterFormationXxSvg;

var y = LetterFormationYySvg;

var z = LetterFormationZzSvg;

var CapitalAndLower = {
  a: a,
  b: b,
  c: c,
  d: d,
  e: e,
  f: f,
  g: g,
  h: h,
  i: i,
  j: j,
  k: k,
  l: l,
  m: m,
  n: n,
  o: o,
  p: p,
  q: q,
  r: r,
  s: s,
  t: t,
  u: u,
  v: v,
  w: w,
  x: x,
  y: y,
  z: z
};

var a$1 = LetterFormationASvg;

var b$1 = LetterFormationBSvg;

var c$1 = LetterFormationCSvg;

var d$1 = LetterFormationDSvg;

var e$1 = LetterFormationESvg;

var f$1 = LetterFormationFSvg;

var g$1 = LetterFormationGSvg;

var h$1 = LetterFormationHSvg;

var i$1 = LetterFormationISvg;

var j$1 = LetterFormationJSvg;

var k$1 = LetterFormationKSvg;

var l$1 = LetterFormationLSvg;

var m$1 = LetterFormationMSvg;

var n$1 = LetterFormationNSvg;

var o$1 = LetterFormationOSvg;

var p$1 = LetterFormationPSvg;

var q$1 = LetterFormationQSvg;

var r$1 = LetterFormationRSvg;

var s$1 = LetterFormationSSvg;

var t$1 = LetterFormationTSvg;

var u$1 = LetterFormationUSvg;

var v$1 = LetterFormationVSvg;

var w$1 = LetterFormationWSvg;

var x$1 = LetterFormationXSvg;

var y$1 = LetterFormationYSvg;

var z$1 = LetterFormationZSvg;

var Capital = {
  a: a$1,
  b: b$1,
  c: c$1,
  d: d$1,
  e: e$1,
  f: f$1,
  g: g$1,
  h: h$1,
  i: i$1,
  j: j$1,
  k: k$1,
  l: l$1,
  m: m$1,
  n: n$1,
  o: o$1,
  p: p$1,
  q: q$1,
  r: r$1,
  s: s$1,
  t: t$1,
  u: u$1,
  v: v$1,
  w: w$1,
  x: x$1,
  y: y$1,
  z: z$1
};

var a$2 = LetterFormationaSvg;

var b$2 = LetterFormationbSvg;

var c$2 = LetterFormationcSvg;

var d$2 = LetterFormationdSvg;

var e$2 = LetterFormationeSvg;

var f$2 = LetterFormationfSvg;

var g$2 = LetterFormationgSvg;

var h$2 = LetterFormationhSvg;

var i$2 = LetterFormationiSvg;

var j$2 = LetterFormationjSvg;

var k$2 = LetterFormationkSvg;

var l$2 = LetterFormationlSvg;

var m$2 = LetterFormationmSvg;

var n$2 = LetterFormationnSvg;

var o$2 = LetterFormationoSvg;

var p$2 = LetterFormationpSvg;

var q$2 = LetterFormationqSvg;

var r$2 = LetterFormationrSvg;

var s$2 = LetterFormationsSvg;

var t$2 = LetterFormationtSvg;

var u$2 = LetterFormationuSvg;

var v$2 = LetterFormationvSvg;

var w$2 = LetterFormationwSvg;

var x$2 = LetterFormationxSvg;

var y$2 = LetterFormationySvg;

var z$2 = LetterFormationzSvg;

var Lower = {
  a: a$2,
  b: b$2,
  c: c$2,
  d: d$2,
  e: e$2,
  f: f$2,
  g: g$2,
  h: h$2,
  i: i$2,
  j: j$2,
  k: k$2,
  l: l$2,
  m: m$2,
  n: n$2,
  o: o$2,
  p: p$2,
  q: q$2,
  r: r$2,
  s: s$2,
  t: t$2,
  u: u$2,
  v: v$2,
  w: w$2,
  x: x$2,
  y: y$2,
  z: z$2
};

var n0 = Numeral0Svg;

var n1 = Numeral1Svg;

var n2 = Numeral2Svg;

var n3 = Numeral3Svg;

var n4 = Numeral4Svg;

var n5 = Numeral5Svg;

var n6 = Numeral6Svg;

var n7 = Numeral7Svg;

var n8 = Numeral8Svg;

var n9 = Numeral9Svg;

var numbers0to9 = Numerals0Svg$2;

var numerals0to4 = Numerals0Svg$1;

var numerals1to3 = Numerals1Svg;

var numerals4to6 = Numerals4Svg;

var numerals5to9 = Numerals5Svg;

var numerals7to9 = Numerals7Svg;

var Numbers = {
  n0: n0,
  n1: n1,
  n2: n2,
  n3: n3,
  n4: n4,
  n5: n5,
  n6: n6,
  n7: n7,
  n8: n8,
  n9: n9,
  numbers0to9: numbers0to9,
  numerals0to4: numerals0to4,
  numerals1to3: numerals1to3,
  numerals4to6: numerals4to6,
  numerals5to9: numerals5to9,
  numerals7to9: numerals7to9
};

var HwGameIcons = {
  CapitalAndLower: CapitalAndLower,
  Capital: Capital,
  Lower: Lower,
  Numbers: Numbers
};

var dictionary = {};

dictionary["Comprehension"] = comprehensionStrandIcon;

dictionary["Grammar"] = grammarStrandIcon;

dictionary["Decodable"] = decodableStrandIcon;

dictionary["Handwriting"] = handwritingStrandIcon;

dictionary["Bouncy Line Letters"] = bouncyLineLetterFamilyIcon;

dictionary["Curly Line Letters"] = curlyLineLetterFamilyIcon;

dictionary["Straight Line Letters"] = straightLineLetterFamilyIcon;

dictionary["Zig-Zag Letters"] = zigZagLetterFamilyIcon;

dictionary["Numerals 0-9"] = numeralsZeroToNineIcon;

dictionary["Numerals"] = numeralsZeroToNineIcon;

dictionary["Phonics"] = phonicsStrandIcon;

dictionary["Sight Words"] = sightWordsStrandIcon;

dictionary["Spelling"] = spellingStrandIcon;

dictionary["Writing"] = writingStrandIcon;

var dictionary$1 = {};

dictionary$1["Book"] = seniorBookStrandIcon;

dictionary$1["Comprehension"] = seniorComprehensionStrandIcon;

dictionary$1["Grammar"] = seniorGrammarStrandIcon;

dictionary$1["Spelling"] = seniorSpellingStrandIcon;

var dictionary$2 = {};

dictionary$2["Level 1"] = level1Svg;

dictionary$2["Level 2"] = level2Svg;

dictionary$2["Level 3"] = level3Svg;

dictionary$2["Level 4"] = level4Svg;

dictionary$2["Animal Homes"] = animalHomes;

dictionary$2["Cat and Mouse"] = catAndMouse;

dictionary$2["Cats or Dogs?"] = catsOrDogs;

dictionary$2["Chickens"] = chickens;

dictionary$2["Fruit"] = fruit;

dictionary$2["Growing Tomatoes"] = growingTomatoes;

dictionary$2["We Grow Vegetables"] = weGrowVegetables;

dictionary$2["Hats"] = hats;

dictionary$2["Hen's Egg"] = hensEgg;

dictionary$2["I Like Dogs"] = iLikeDogs;

dictionary$2["Jen's Pug"] = jensPug;

dictionary$2["Kittens"] = kittens;

dictionary$2["Little Tiger's Loose Tooth"] = littleTigersLooseTooth;

dictionary$2["Making Breakfast"] = makingBreakfast;

dictionary$2["Monkey"] = monkey;

dictionary$2["Mothers and Babies"] = mothersAndBabies;

dictionary$2["My Weather"] = myWeather;

dictionary$2["See Me Brush My Teeth"] = seeMeBrushMyTeeth;

dictionary$2["Silly Fox"] = sillyFox;

dictionary$2["Trucks"] = trucks;

dictionary$2["Bug's Birthday"] = bugsBirthday;

dictionary$2["Children Should Learn How to Cook"] = childrenShouldLearnHowToCook;

dictionary$2["City or Country?"] = cityOrCountry;

dictionary$2["Dippy Eggs"] = dippyEggs;

dictionary$2["How to Draw a Cat"] = howToDrawACat;

dictionary$2["Koala's Bike Trip"] = koalasBikeTrip;

dictionary$2["Little Sloth's New Friend"] = littleSlothsNewFriend;

dictionary$2["Mug Cakes"] = mugCakes;

dictionary$2["No Haircut for Me!"] = noHaircutForMe;

dictionary$2["Oh no, Brian!"] = ohNoBrian;

dictionary$2["Penguin's Snow Cone Shop"] = penguinsSnowConeShop;

dictionary$2["Penguins"] = penguins;

dictionary$2["Strawberry Picking"] = strawberryPicking;

dictionary$2["Strawberry Smoothie"] = strawberrySmoothie;

dictionary$2["Swimming Lessons for Little Platypus"] = swimmingLessonsForLittlePlatypus;

dictionary$2["To the Moon"] = toTheMoon;

dictionary$2["Water"] = water;

dictionary$2["A Trip to Korea"] = aTripToKorea;

dictionary$2["Banana Muffins"] = bananaMuffins;

dictionary$2["Camping in Australia"] = campingInAustralia;

dictionary$2["Cheese and Vegemite Scrolls"] = cheeseAndVegemiteScrolls;

dictionary$2["City Mouse Bush Mouse"] = cityMouseBushMouse;

dictionary$2["Cricket"] = cricket;

dictionary$2["David's Eyes"] = davidsEyes;

dictionary$2["Doctors"] = doctors;

dictionary$2["Eric Carle"] = ericCarle;

dictionary$2["Fruity Kebabs"] = fruityKebabs;

dictionary$2["Landmarks"] = landmarks;

dictionary$2["My Dad the Mailman"] = myDadTheMailman;

dictionary$2["My Uncle the Pilot"] = myUncleThePilot;

dictionary$2["Otters"] = otters;

dictionary$2["Owls"] = owls;

dictionary$2["People Should Grow Their Own Food"] = peopleShouldGrowTheirOwnFood;

dictionary$2["Police Officers"] = police;

dictionary$2["Sara Snail's Sleepover"] = saraSnailsSleepover;

dictionary$2["Shopkeepers"] = shopkeepers;

dictionary$2["Teachers"] = teachers;

var dictionary$3 = {};

dictionary$3["Letter Formation Aa"] = a;

dictionary$3["Letter Formation Bb"] = b;

dictionary$3["Letter Formation Cc"] = c;

dictionary$3["Letter Formation Dd"] = d;

dictionary$3["Letter Formation Ee"] = e;

dictionary$3["Letter Formation Ff"] = f;

dictionary$3["Letter Formation Gg"] = g;

dictionary$3["Letter Formation Hh"] = h;

dictionary$3["Letter Formation Ii"] = i;

dictionary$3["Letter Formation Jj"] = j;

dictionary$3["Letter Formation Kk"] = k;

dictionary$3["Letter Formation Ll"] = l;

dictionary$3["Letter Formation Mm"] = m;

dictionary$3["Letter Formation Nn"] = n;

dictionary$3["Letter Formation Oo"] = o;

dictionary$3["Letter Formation Pp"] = p;

dictionary$3["Letter Formation Qq"] = q;

dictionary$3["Letter Formation Rr"] = r;

dictionary$3["Letter Formation Ss"] = s;

dictionary$3["Letter Formation Tt"] = t;

dictionary$3["Letter Formation Uu"] = u;

dictionary$3["Letter Formation Vv"] = v;

dictionary$3["Letter Formation Ww"] = w;

dictionary$3["Letter Formation Xx"] = x;

dictionary$3["Letter Formation Yy"] = y;

dictionary$3["Letter Formation Zz"] = z;

dictionary$3["Letter Formation A"] = a$1;

dictionary$3["Letter Formation B"] = b$1;

dictionary$3["Letter Formation C"] = c$1;

dictionary$3["Letter Formation D"] = d$1;

dictionary$3["Letter Formation E"] = e$1;

dictionary$3["Letter Formation F"] = f$1;

dictionary$3["Letter Formation G"] = g$1;

dictionary$3["Letter Formation H"] = h$1;

dictionary$3["Letter Formation I"] = i$1;

dictionary$3["Letter Formation J"] = j$1;

dictionary$3["Letter Formation K"] = k$1;

dictionary$3["Letter Formation L"] = l$1;

dictionary$3["Letter Formation M"] = m$1;

dictionary$3["Letter Formation N"] = n$1;

dictionary$3["Letter Formation O"] = o$1;

dictionary$3["Letter Formation P"] = p$1;

dictionary$3["Letter Formation Q"] = q$1;

dictionary$3["Letter Formation R"] = r$1;

dictionary$3["Letter Formation S"] = s$1;

dictionary$3["Letter Formation T"] = t$1;

dictionary$3["Letter Formation U"] = u$1;

dictionary$3["Letter Formation V"] = v$1;

dictionary$3["Letter Formation W"] = w$1;

dictionary$3["Letter Formation X"] = x$1;

dictionary$3["Letter Formation Y"] = y$1;

dictionary$3["Letter Formation Z"] = z$1;

dictionary$3["Letter Formation a"] = a$2;

dictionary$3["Letter Formation b"] = b$2;

dictionary$3["Letter Formation c"] = c$2;

dictionary$3["Letter Formation d"] = d$2;

dictionary$3["Letter Formation e"] = e$2;

dictionary$3["Letter Formation f"] = f$2;

dictionary$3["Letter Formation g"] = g$2;

dictionary$3["Letter Formation h"] = h$2;

dictionary$3["Letter Formation i"] = i$2;

dictionary$3["Letter Formation j"] = j$2;

dictionary$3["Letter Formation k"] = k$2;

dictionary$3["Letter Formation l"] = l$2;

dictionary$3["Letter Formation m"] = m$2;

dictionary$3["Letter Formation n"] = n$2;

dictionary$3["Letter Formation o"] = o$2;

dictionary$3["Letter Formation p"] = p$2;

dictionary$3["Letter Formation q"] = q$2;

dictionary$3["Letter Formation r"] = r$2;

dictionary$3["Letter Formation s"] = s$2;

dictionary$3["Letter Formation t"] = t$2;

dictionary$3["Letter Formation u"] = u$2;

dictionary$3["Letter Formation v"] = v$2;

dictionary$3["Letter Formation w"] = w$2;

dictionary$3["Letter Formation x"] = x$2;

dictionary$3["Letter Formation y"] = y$2;

dictionary$3["Letter Formation z"] = z$2;

dictionary$3["Numeral 0"] = n0;

dictionary$3["Numeral 1"] = n1;

dictionary$3["Numeral 2"] = n2;

dictionary$3["Numeral 3"] = n3;

dictionary$3["Numeral 4"] = n4;

dictionary$3["Numeral 5"] = n5;

dictionary$3["Numeral 6"] = n6;

dictionary$3["Numeral 7"] = n7;

dictionary$3["Numeral 8"] = n8;

dictionary$3["Numeral 9"] = n9;

dictionary$3["Numerals 0-9"] = numbers0to9;

dictionary$3["Numerals 0-4"] = numerals0to4;

dictionary$3["Numerals 1-3"] = numerals1to3;

dictionary$3["Numerals 4-6"] = numerals4to6;

dictionary$3["Numerals 5-9"] = numerals5to9;

dictionary$3["Numerals 7-9"] = numerals7to9;

var juniorIconByTitle = dictionary;

var seniorIconByTitle = dictionary$1;

var comprehensionIconByTitle = dictionary$2;

var gameIconByTitle = dictionary$3;

export {
  academyHouseSvg ,
  comprehensionStrandIcon ,
  decodableStrandIcon ,
  grammarStrandIcon ,
  handwritingStrandIcon ,
  bouncyLineLetterFamilyIcon ,
  curlyLineLetterFamilyIcon ,
  straightLineLetterFamilyIcon ,
  zigZagLetterFamilyIcon ,
  numeralsZeroToNineIcon ,
  phonicsStrandIcon ,
  sightWordsStrandIcon ,
  spellingStrandIcon ,
  writingStrandIcon ,
  seniorBookStrandIcon ,
  seniorComprehensionStrandIcon ,
  seniorGrammarStrandIcon ,
  seniorSpellingStrandIcon ,
  starFilledSvg ,
  starUnfilledSvg ,
  grammarActivityIcon ,
  comprehensionActivityIcon ,
  spellingLessonActivityIcon ,
  spellTestActivityIcon ,
  ComprehensionLevels ,
  HwGameIcons ,
  juniorIconByTitle ,
  seniorIconByTitle ,
  comprehensionIconByTitle ,
  gameIconByTitle ,
}
/*  Not a pure module */
